import type { ReactNode } from "react";

export interface MenuHeaderProps {
  title: ReactNode;

  description?: ReactNode;

  action?: ReactNode;
}

export function MenuHeader({ title, description, action }: Readonly<MenuHeaderProps>) {
  return (
    <div className="border-b border-border-subtle px-3 py-2">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-content-primary">{title}</span>
        {action}
      </div>
      {description && <span className="mt-1 block text-xs text-content-tertiary">{description}</span>}
    </div>
  );
}
